// docs/BRAND_GUIDELINES.md: control edges have at least 3:1 canvas contrast.
const LIGHT = { isDark: false, page: '#FFFFFF', ink: '#040404', muted: '#616161', fill: '#F5F5F5', rule: '#E5E5E5', edge: '#8C8C8C', error: '#B42318' };
const DARK = { isDark: true, page: '#040404', ink: '#FFFFFF', muted: '#B3B3B3', fill: '#1C1C1C', rule: '#383838', edge: '#8A8A8A', error: '#FF6B5F' };

export const businessBrand = isDark => (isDark ? DARK : LIGHT);
